export const RIGHT_PANEL_WIDTH = 392;

export const RIGHT_SIDE_PANEL_EXPERIENCE = {
	experience: 'jiraHomeRightSidePanel',
	experienceId: undefined,
	analyticsSource: 'jira-home',
};
export const JIRA_HOME_PAGE_RIGHT_SIDE_PANEL = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';
